export const CONST = {
  END_SCAN_SUCCESS_MODAL: {
    HEADER: $localize`End Scan Successful`,
    MESSAGE: $localize`You have successfully ended the scan.`,
    OK: $localize`Ok`,
  },
  CONFIRM_END_SCAN_MODAL: {
    HEADER: $localize`Confirm End of Outbound`,
    MOVEMENT: $localize`Movement`,
    DEPART_DATE: $localize`Depart Date`,
    BACK: $localize`Back`,
    END: $localize`End`,
  },
};
